function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Label from '../Label';
import Icon from '../Icon';
import Option from './Option';
import OptGroup from './OptGroup';
import { getValidElementProps } from '../utils/htmlValidProps';

require('xps-style/core/select.css');

var propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,

  /** Add required text to select field */
  lblRequired: PropTypes.bool,

  /** Display optional next to the label */
  optional: PropTypes.bool,

  /** Array of select options to display */
  options: PropTypes.array,

  /** Label of select field */
  label: PropTypes.string,
  className: PropTypes.string,
  elementSize: PropTypes.oneOf(['large', 'medium', 'small']),

  /** Set the select field from options */
  defaultSelection: PropTypes.string,
  error: PropTypes.string,
  description: PropTypes.string,

  /** Func to handle changes */
  onChangeValue: PropTypes.func,

  /** key of key,value pair to display from options */
  optKey: PropTypes.string,
  multiple: PropTypes.bool,

  /** Place holder text you wish to display */
  placeholder: PropTypes.string,
  children: PropTypes.node,

  /** Key of nested array */
  optGroupKey: PropTypes.string,

  /** Key of group label */
  optGroupLabelKey: PropTypes.string,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool
};
var defaultProps = {
  onChangeValue: function onChangeValue() {},
  optGroupLabelKey: 'label',
  optGroupKey: 'children',
  optKey: 'label',
  elementSize: 'small'
};

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleDefaultSelect", function (event) {
      var onChangeValue = _this.props.onChangeValue;
      event.preventDefault();
      onChangeValue(event.target.value);
    });

    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _cx, _cx2;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          lblRequired = _this$props.lblRequired,
          label = _this$props.label,
          options = _this$props.options,
          className = _this$props.className,
          elementSize = _this$props.elementSize,
          defaultSelection = _this$props.defaultSelection,
          description = _this$props.description,
          error = _this$props.error,
          optKey = _this$props.optKey,
          multiple = _this$props.multiple,
          placeholder = _this$props.placeholder,
          children = _this$props.children,
          optGroupKey = _this$props.optGroupKey,
          optGroupLabelKey = _this$props.optGroupLabelKey,
          optional = _this$props.optional,
          removeMarginTop = _this$props.removeMarginTop;
      var labelId = id || name;
      var selectAdaProps = {
        'aria-invalid': !!error,
        'aria-required': lblRequired,
        'aria-describedby': "".concat(labelId, "__description")
      };
      var selectComponentProps = getValidElementProps('select', this.props);

      var selectProps = _objectSpread(_objectSpread({}, selectComponentProps), selectAdaProps);

      var ntClass = cx((_cx = {
        select__field: true
      }, _defineProperty(_cx, "select--".concat(elementSize), true), _defineProperty(_cx, 'select--multiple', multiple), _defineProperty(_cx, 'input-skin', true), _defineProperty(_cx, 'input-skin--error', error), _defineProperty(_cx, 'select-skin--icon', !multiple), _cx));
      var iconClass = cx((_cx2 = {
        select__icon: true
      }, _defineProperty(_cx2, "select__icon-".concat(elementSize), true), _defineProperty(_cx2, 'select__icon-error', error), _cx2));
      var descClass = cx({
        select__info: true,
        'color-text': true
      });
      var errorClass = cx({
        select__info: true,
        'color-text--error': true
      });
      var lblClass = cx({
        'select__label-required__container': true,
        'select__label--no-margintop': removeMarginTop
      });
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: lblClass
      }, label !== undefined ? /*#__PURE__*/React.createElement(Label, {
        name: labelId,
        text: label,
        className: "select__label",
        optional: !lblRequired && optional
      }) : null, lblRequired ? /*#__PURE__*/React.createElement("span", {
        className: "select__label-required font-sm"
      }, "Required") : null), /*#__PURE__*/React.createElement("select", _extends({
        multiple: multiple,
        id: labelId,
        name: name,
        value: defaultSelection,
        className: ntClass,
        onChange: this.handleDefaultSelect
      }, selectProps), children, options ? /*#__PURE__*/React.createElement(React.Fragment, null, placeholder ? /*#__PURE__*/React.createElement(Option, {
        id: "disabled-option",
        disabled: true,
        "aria-disabled": true,
        selected: true
      }, placeholder) : null, options.map(function (option) {
        if (option[optGroupKey] && option[optGroupLabelKey]) {
          return /*#__PURE__*/React.createElement(OptGroup, {
            key: option[optGroupLabelKey],
            options: option[optGroupKey],
            label: option[optGroupLabelKey],
            optKey: optKey
          });
        }

        return /*#__PURE__*/React.createElement(Option, {
          key: option[optKey],
          value: option[optKey]
        }, option[optKey]);
      })) : null), multiple ? null : /*#__PURE__*/React.createElement(Icon, {
        className: iconClass,
        name: "arrow_drop_down"
      }), error ? /*#__PURE__*/React.createElement("div", {
        role: "alert",
        className: errorClass
      }, error) : null, description && !error ? /*#__PURE__*/React.createElement("div", {
        id: "".concat(labelId, "__description"),
        className: descClass
      }, description) : null);
    }
  }]);

  return Select;
}(React.Component);

Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
Select.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleDefaultSelect",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "event",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Select",
  "props": {
    "onChangeValue": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Func to handle changes"
    },
    "optGroupLabelKey": {
      "defaultValue": {
        "value": "'label'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Key of group label"
    },
    "optGroupKey": {
      "defaultValue": {
        "value": "'children'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Key of nested array"
    },
    "optKey": {
      "defaultValue": {
        "value": "'label'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "key of key,value pair to display from options"
    },
    "elementSize": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "lblRequired": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Add required text to select field"
    },
    "optional": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display optional next to the label"
    },
    "options": {
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Array of select options to display"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Label of select field"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "defaultSelection": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Set the select field from options"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "multiple": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Place holder text you wish to display"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    }
  }
};
export default Select;